import { Box, Button, Typography } from '@mui/material';
import { FORM_STATUS } from './SubOrganizations';
import AnimateButton from '../../../Components/Theme/Extended/AnimateButton';
import SubmitButton from '../../../Components/Theme/Extended/SubmitButton';
import { palette } from '../../../styles/variables/colors';
import { useEffect } from 'react';
import { subOrganizationsStore } from '../../../Stores/SubOrganizationsStore';

const EMPTY_STRING = '---';

const Field = ({ title, value }) => {
  return (
    <Box className="flex items-center mb-2">
      <Typography
        variant="h5"
        className="pr-5  min-w-[250px]"
        fontWeight="bold"
      >
        {`${title}:`}
      </Typography>
      <Typography variant="h5" className="pr-5">
        {value || EMPTY_STRING}
      </Typography>
    </Box>
  );
};

const SubOrgonizationsViewForm = ({ handleAction, item }) => {
  useEffect(() => {
    subOrganizationsStore.getAllOrganizations();
  }, [subOrganizationsStore.organizationsList?.length]);

  return (
    <Box className="mr-5">
      <Typography className="pb-5" variant="h3" color={'#003375'} gutterBottom>
        Προβολή Γενικής Διεύθυνσης
      </Typography>
      <Field title="Ονομασία" value={item?.name} />
      <Field
        title="Οργανισμός"
        value={
          subOrganizationsStore.organizationsList?.find(
            (c) => c.id === item?.organizationId
          )?.name
        }
      />
      <Field title="Τηλέφωνο" value={item?.tel} />
      <Field title="Περιγραφή" value={item?.description} />
      <Field title="Τοποθεσία" value={item?.address} />
      <Field title="Ενεργή" value={item?.isActive ? 'Ναι' : 'Όχι'} />
      <Box className="flex justify-end">
        <AnimateButton>
          <Button
            sx={{
              backgroundColor: '#184682',
              color: '#f9f9f9',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#184682',
                color: '#f9f9f9',
              },
              fontSize: '1rem',
            }}
            onClick={() => {
              handleAction({ formStatus: FORM_STATUS.HIDDEN });
            }}
            variant="contained"
            type="submit"
          >
            Κλείσιμο
          </Button>
        </AnimateButton>
      </Box>
    </Box>
  );
};

export default SubOrgonizationsViewForm;
